export default __webpack_public_path__ + "static/media/mesa_corte.78776fe5.png";